import type { CompileResult } from "../types/render";
import type { CompiledTemplate, LabelTemplateV2 } from "../types/template";
import { normalizeSpacing } from "../utils/spacing";
import { validateTemplate } from "../validate/validateTemplate";
import { compileContainers } from "./compileElements";
import { resolveCompileDefaults } from "./defaults";
import { deepFreeze } from "./freeze";
import { assertTemplateSchemaVersion } from "./schemaCheck";

export function compileTemplate(template: LabelTemplateV2): CompileResult {
  assertTemplateSchemaVersion(template);

  const validation = validateTemplate(template);
  const defaults = resolveCompileDefaults(template.defaults);

  const compiled: CompiledTemplate = {
    schemaVersion: "2.0",
    id: template.id,
    name: template.name,
    variables: template.variables.map((variable) => ({ ...variable })),
    canvas: {
      widthMm: template.canvas.widthMm,
      heightMm: template.canvas.heightMm,
      paddingMm: normalizeSpacing(template.canvas.paddingMm),
    },
    defaults,
    requiredVariables: validation.requiredVariables,
    containers: compileContainers(template, defaults.font, defaults.barcode),
  };

  return {
    templateId: template.id,
    version: "2.0",
    requiredVariables: validation.requiredVariables,
    warnings: validation.warnings,
    compiled: deepFreeze(compiled),
  };
}
